import { createBuildingDetailsQuery } from '@hcr/api/optimizely'

import { HTTP_CONFIG } from '../../../../configs'

export const useBuildingDetailsQuery = createBuildingDetailsQuery(HTTP_CONFIG.API.Optimizely.url)
